// export const bnURLref = "https://shy-red-trout-boot.cyclic.app"
// export const baseURLref = 'https://shy-red-trout-boot.cyclic.app'


export const bnURLref = "https://akademi.onrender.com"
export const baseURLref = 'https://akademi.onrender.com'